import { Component, useEffect } from "react";
import Lenis from "lenis";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Collections from "./components/Collections";
import Spotlight from "./components/Spotlight";
import MoqBand from "./components/MoqBand";
import HowItWorks from "./components/HowItWorks";
import Footer from "./components/Footer";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen grid place-items-center bg-cream text-ink p-8 text-center">
          <p>Something went wrong. Please refresh the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="bg-cream text-ink font-sans antialiased selection:bg-coral selection:text-cream">
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Collections />
          <Spotlight />
          <MoqBand />
          <HowItWorks />
        </main>
        <Footer />
        <div className="grain" aria-hidden="true" />
      </div>
    </ErrorBoundary>
  );
}

export default App;
